window.waveModal = {

}

async function runModalAction(button) {
    const action = button?.dataset?.modalAction;
    if (!action || !window.waveFunc?.[action]) return;

    switch (action) {
        case 'showPatientForm':
            await window.waveFunc.showPatientForm(
                button.dataset.modalPatientId,
                button.dataset.modalFormId
            );
            break;
    }
}

function Modal() {
    this.createModal = async (id, button) => {
        const domParser = new DOMParser();
        const modalNode = `
            <div class="wave-line-modal__wrap" id="modal-wrap" data-id="${id}">
                <div class="wave-line-modal" id="modal">
                    <button class="wave-line-modal__close js-close-modal" id="close-modal">
                        <svg>
                            <use xlink:href="#close-icon"></use>
                        </svg>
                    </button>
                </div>
            </div>
        `;
        const modalHtml = domParser.parseFromString(modalNode, "text/html");
        let modalWrap = modalHtml.getElementById('modal-wrap');
        document.body.appendChild(modalWrap);
        window.waveModal[id] = true;
        await runModalAction(button);
    }
    this.showModal = () => {
        const event = document.createEvent('Event');
        let modalWrap = document.getElementById('modal-wrap');
        let body = document.body;
        modalWrap.style.display = 'flex';
        body.style.overflow = 'hidden';
        event.initEvent('showModal', true, true);
        document.dispatchEvent(event);
        let listener = function (e) {
            if(e.key === "Escape") {
                modal.closeModal();
                document.removeEventListener('keydown', listener, false);
            }
        };
        document.addEventListener('keydown', listener, false);
    }
    this.closeModal = () => {
        let body = document.body;
        let modalWrap = document.getElementById('modal-wrap');
        modalWrap.style.display = 'none'
        body.style.overflow = 'auto'
    }
    this.removeModal = () => {
        let modalWrap = document.getElementById('modal-wrap');
        document.body.removeChild(modalWrap);
    }
}

let modal = new Modal();

let modalButtons = document.querySelectorAll('.js-modal');
if(modalButtons) {
    modalButtons.forEach(modalButton => {
        modalButton.addEventListener('click', event => {
            const button = event.currentTarget;
            let id = button.getAttribute('data-unique-id');
            if(window.waveModal.hasOwnProperty(id) && id == document.getElementById('modal-wrap').dataset.id) {

            } else if (Object.keys(window.waveModal).length && id != document.getElementById('modal-wrap').dataset.id) {
                modal.removeModal();
                window.waveModal = {};
                modal.createModal(id, button);
            } else {
                modal.createModal(id, button);
            }
            modal.showModal()
        });
    });
}

document.addEventListener('showModal',  () => {
    let closeButton = document.getElementById('close-modal');
    closeButton.addEventListener('click', () => modal.closeModal());
});
